module.exports = __webpack_public_path__ + "img/logo-blue.384d2253.png";